module.exports = __webpack_public_path__ + "static/media/35.321f6153.ogg";